import axios from "axios";
import RBAC from "./rbac";

const api = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});

let isRefreshing = false;
let refreshWaitQueue = [];

function onRefreshed(newAccessToken) {
  refreshWaitQueue.forEach((cb) => cb(newAccessToken));
  refreshWaitQueue = [];
}

function addToQueue(cb) {
  refreshWaitQueue.push(cb);
}

// Request
api.interceptors.request.use(
  (config) => {
    if (!config.url.includes("/api/auth/refresh")) {
      const token = localStorage.getItem("accessToken");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (!error.response) {
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve) => {
          addToQueue((newAccessToken) => {
            originalRequest._retry = true;
            if (newAccessToken) {
              originalRequest.headers[
                "Authorization"
              ] = `Bearer ${newAccessToken}`;
            }
            resolve(api(originalRequest));
          });
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token");

        // Nếu BE dùng cookie HttpOnly cho refresh: dùng withCredentials
        // const res = await axios.post("http://localhost:8080/api/auth/refresh", null, { withCredentials: true });
        const res = await axios.post(process.env.VUE_APP_BASEURL + "/api/auth/refresh", {
          refreshToken,
        });

        const newAccessToken = res.data?.data?.accessToken;
        const newRefreshToken = res.data?.data?.refreshToken;

        if (!newAccessToken || !newRefreshToken) {
          throw new Error("Invalid refresh response");
        }

        localStorage.setItem("accessToken", newAccessToken);
        localStorage.setItem("refreshToken", newRefreshToken);
        api.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${newAccessToken}`;

        onRefreshed(newAccessToken);

        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (err) {
        console.error("Refresh token error", err);
        onRefreshed(null);
        localStorage.clear();
        RBAC.clear();
        setTimeout(() => (window.location.href = "/login"), 0);
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
